// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AppEvent } from '@interfaces/interfaces';
import { SuccessModalService } from '@services/success-modal.service';
import { UserService } from '@services/user.service';
import { takeWhile } from 'rxjs/operators';
import { UserNotificationType } from '../../interfaces/user.interfaces';

@Component({
    selector: 'app-profile-notifications',
    templateUrl: './profile-notifications.component.html',
    styleUrls: ['./profile-notifications.component.scss'],
})
export class ProfileNotificationsComponent implements OnDestroy {
    @Output() public outEvent: EventEmitter<AppEvent> = new EventEmitter();
    public notificationTypes = UserNotificationType;
    public notificationTypesKeys = Object.values(UserNotificationType).filter((f) => !isNaN(Number(f)));
    public notificationType: any = UserNotificationType.Both;
    profileForm: FormGroup;
    private isComponentAlive = true;
    public showSaveButton = true;

    constructor(
        private readonly userService: UserService,
        private successModalService: SuccessModalService
    ) {
        this.profileForm = new FormGroup({});

        if (this.userService.user.emailAlerts && !this.userService.user.textAlerts) {
            this.notificationType = UserNotificationType.Email;
        } else if (!this.userService.user.emailAlerts && this.userService.user.textAlerts) {
            this.notificationType = UserNotificationType.Text;
        } else if (this.userService.user.emailAlerts && this.userService.user.textAlerts) {
            this.notificationType = UserNotificationType.Both;
        }

        if (window.location.pathname.includes('welcome')) {
            this.showSaveButton = false;
        }
    }

    onChange(event: any): void {
        this.outEvent.emit({
            context: 'notification',
            data: event,
        });
    }

    saveProfile(): void {
        if (this.profileForm.valid) {
            this.outEvent.emit({
                context: 'loader',
                data: true,
            });

            this.userService
                .updateUserNotification$(
                    this.userService.user.email,
                    this.userService.user.firstName,
                    this.userService.user.lastName,
                    this.userService.user.phone,
                    UserNotificationType[this.notificationType],
                    this.userService.user.dealerId
                )
                .pipe(takeWhile(() => this.isComponentAlive))
                .subscribe((response) => {
                    //TODO: need to emit this to the user
                    if (typeof response == typeof this.userService.user) {
                        this.successModalService.showSuccess({
                            title: 'Notifications Updated',
                            content: 'You have successfully updated your notification preferences',
                        });
                    }
                    this.outEvent.emit({
                        context: 'loader',
                        data: false,
                    });
                });
        }
    }

    ngOnDestroy(): void {
        this.isComponentAlive = false;
    }
}
